/**
 * @file Token-based page scroll locking for modal surfaces.
 */

const activeLocks = new Set();
let snapshot = null;

function getScrollY() {
  return window.scrollY || document.documentElement.scrollTop || 0;
}

function getScrollbarWidth() {
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

/**
 * Locks background page scroll while preserving the current scroll position.
 * @param {string|symbol|object} token Unique lock owner token.
 * @returns {void}
 */
export function lockPageScroll(token) {
  if (!token || activeLocks.has(token)) {return;}
  activeLocks.add(token);
  if (activeLocks.size > 1) {return;}

  const scrollbarWidth = getScrollbarWidth();
  snapshot = {
    overflow: document.body.style.overflow,
    paddingRight: document.body.style.paddingRight,
    position: document.body.style.position,
    scrollY: getScrollY(),
    top: document.body.style.top,
    width: document.body.style.width,
  };

  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.top = `-${snapshot.scrollY}px`;
  document.body.style.width = "100%";
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

/**
 * Releases a previous page scroll lock.
 * @param {string|symbol|object} token Lock owner token.
 * @returns {void}
 */
export function unlockPageScroll(token) {
  if (!token || !activeLocks.has(token)) {return;}
  activeLocks.delete(token);
  if (activeLocks.size > 0) {return;}

  const scrollY = snapshot?.scrollY || 0;
  document.body.style.overflow = snapshot?.overflow || "";
  document.body.style.paddingRight = snapshot?.paddingRight || "";
  document.body.style.position = snapshot?.position || "";
  document.body.style.top = snapshot?.top || "";
  document.body.style.width = snapshot?.width || "";
  snapshot = null;
  window.scrollTo(0, scrollY);
}
